import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { FormControl, TextField, Autocomplete } from "@mui/material";

const FreeTextDropdownController = ({
  name,
  label,
  control,
  errors,
  options = [],
  disabled = false,
}) => {
  const [internalOptions, setInternalOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInternalOptions(options);
  }, [options]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const selectedOption = internalOptions.find(
          (opt) => opt.value === field.value
        );

        return (
          <FormControl fullWidth error={!!errors?.[name]}>
            <Autocomplete
              freeSolo
              forcePopupIcon
              options={internalOptions}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.label
              }
              value={
                selectedOption
                  ? selectedOption
                  : field.value
                  ? { label: field.value, value: field.value }
                  : null
              }
              inputValue={inputValue}
              onInputChange={(event, newInputValue, reason) => {
                setInputValue(newInputValue);

                // Only update form value if the user typed something (not just cleared)
                if (reason === "input") {
                  field.onChange(newInputValue);
                }
              }}
              onChange={(event, newValue) => {
                const valueToSet =
                  typeof newValue === "string"
                    ? newValue
                    : newValue?.value || "";

                if (
                  valueToSet &&
                  !internalOptions.some((opt) => opt.value === valueToSet)
                ) {
                  setInternalOptions((prev) => [
                    ...prev,
                    { label: valueToSet, value: valueToSet },
                  ]);
                }

                field.onChange(valueToSet);
                setInputValue(valueToSet);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  variant="outlined"
                  error={!!errors?.[name]}
                  helperText={errors?.[name]?.message}
                />
              )}
              disabled={disabled}
            />
          </FormControl>
        );
      }}
    />
  );
};

export default FreeTextDropdownController;
